// extracted by mini-css-extract-plugin
export default {"root":"nfaoy","checkbox":"_EOps","input":"fajDc","minus":"QCxjM","tooltip":"_2mrn","tooltipBottom":"_nP1F","tooltipTop":"zq3pt"};